<template>
    <div class="api">
      <div class="left-big" :style="{ left: leftIndex }">
        <div class="letf">
          <div class="ml20">
            <div class="select-box">
              <div class="icon-main"></div>
              <el-input
                v-model.trim="selectVal"
                @input="selectClass"
                placeholder="类筛选搜索"
              ></el-input>
            </div>
            <div
              class="select-box-copy"
              :style="{ left: leftIndex }"
              v-show="leftHeadShow"
            >
              <div class="icon-main"></div>
              <div class="copy-select-box">
                <el-input
                  v-model.trim="selectVal"
                  @input="selectClass"
                  placeholder="类筛选搜索"
                ></el-input>
              </div>
            </div>
            <div class="left-title">类索引页面</div>
            <div class="col-tab">
              <div
                :class="[
                  isSelect == index
                    ? 'col-tab-item col-tab-select'
                    : 'col-tab-item',
                ]"
                @click="typeChoose(index)"
                v-for="(item, index) in clTab"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="buttom-main">
              <div class="view-tab">
                <div
                  :class="[viewSelect ? 'view-tab-item-select' : 'view-tab-item']"
                  @click="changeView(true)"
                >
                  分组视图
                </div>
                <!-- <div
              :class="[viewSelect ? 'view-tab-item' : 'view-tab-item-select']"
              @click="changeView(false)"
            >
              类视图
            </div> -->
              </div>
              <tree-copy
                v-show="viewSelect"
                icon-class="el-icon-plus"
                :accordion="true"
                :data="data"
                :props="defaultProps"
                :highlight-current="true"
                node-key="Name"
                @node-click="handleNodeClick"
                ref="tree"
                empty-text="未搜索到结果"
                style="margin-top: 17px; margin-left: 0"
              ></tree-copy>
            </div>
          </div>
        </div>
      </div>
      <div
        class="api-main-head-copy"
        :style="{ left: mainHeadIndex }"
      >
      <!-- v-show="topHeaderShow" -->
        <div class="breadcrumb" v-show="classDetailShow">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in apiEnc" :key="index">
              {{ item }}</el-breadcrumb-item
            >
            <el-breadcrumb-item style="color: #2c797f">
              {{ apiLabel }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <div class="select-all" @click="handleOpenDlog">
          全文搜索
          <div class="select-all-icon"></div>
        </div>
      </div>
      <div class="mian-big">
        <div class="main" :style="{ left: mainIndex }">
          <div class="api-main-head" v-if="false">
           
            <div class="breadcrumb" v-show="classDetailShow ">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <!-- <el-breadcrumb-item>API文档</el-breadcrumb-item> -->
                <el-breadcrumb-item
                  v-for="(item, index) in apiEnc"
                  :key="index"
                  style="color: rgba(38, 41, 45, 0.6)"
                >
                  {{ item }}</el-breadcrumb-item
                >
                <el-breadcrumb-item style="color: #2c797f">
                  {{ apiLabel }}</el-breadcrumb-item
                >
              </el-breadcrumb>
            </div>
            <div class="select-all" @click="handleOpenDlog">
              全文搜索
              <div class="select-all-icon"></div>
            </div>
          </div>
          <div class="tab-box" v-if="!classDetailShow && isSelect == 0">
               <iframe scrolling="no" id="iframe" :style="{width:'100%',minHeight:wikiIframeHeight}" :src=iframeUrl></iframe>
               <!-- <mark-down></mark-down> -->
          </div>
          <div class="tab-box" v-if="classDetailShow == false && isSelect != 0" >
            <div class="class-title">{{ className }}</div>
            <div class="class-box">
              <div class="flex-alphabetical-index">
                <div
                  class="alphabetical-index"
                  v-for="(item, key) in ClassListData"
                  :key="key"
                >
                  <div class="class-sort-name">{{ key }}</div>
                   <div class="class-sort-name"   style="color:#2c797f;marginTop:10px;fontSize:18px;" v-for="(jtem, key) in item"
                    :key="key">{{ key }}
                       <div
                    class="class-name"
                    v-for="(ktem, key) in jtem"
                    :key="key"
                    @click="gotoDetail(key, ktem)"
                  >
                    {{ key }}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <router-view :key="this.path"></router-view>
      </div>
    </div>
    <div class="line" v-show="classDetailShow"></div>
    <div class="gotop" @click="goTop" v-show="goToShow">
      <i class="el-icon-arrow-up"></i>
    </div>
    <el-dialog
      class="full-text-mask"
      custom-class="full-text-serch"
      :modal="false"
      :before-close="handleCloseModule"
      :visible.sync="dialogVisible"
    >
      <div class="full-text-body">
        <input
          v-model.trim="allSelect"
          placeholder="全文搜索"
          class="full-text-serch-content"
          ref="input"
        />
        <img
          @click="handleCloseModule"
          class="full-text-img"
          src="../../assets/img/Frame 2343.png"
        />
        <div class="select-all-icon"></div>
      </div>
      <div class="full-text-serch-drop-down" ref="searchList">
        <div
          v-show="isShowSerchingTips"
          :class="
    serchLoading ? 'full-text-serch-tips' : 'full-text-serch-none'
    "
          slot="empty"
        >
          {{ serchLoading ? "正在搜索..." : searchMessage }}
        </div>
        <div
          v-show="!isShowSerchingTips"
          v-for="(item, index) in searchList"
          :key="index"
          class="full-text-serch-item"
          @click="
() => {
    handleCloseModule(), gotoDetail(item.Name, item.Path, item.Type, item.Context);
}
"
        >
          <div class="full-text-serch-item-top">
    <span class="full-text-serch-item-title">
    {{ item.Name }}
</span>
            <span v-show="item.Summary" class="full-text-serch-item-summry">
                {{ item.Summary }}
              </span>
            </div>
            <div
              v-show="item.Context"
              v-html="item.Context[0]"
              class="full-text-serch-item-bottom"
            ></div>
          </div>
          <div
            class="history-content"
            v-show="!searchList.length && !isShowSerchingTips && historyData.length > 0"
          >
            <div class="history-content-top">
              <div class="histoty-tit">搜索历史</div>
              <div
                class="delect-all-his-icon el-icon-delete"
                @click="delectHistory"
              ></div>
            </div>
            <div
              class="history-content-down"
              v-for="(item, index) in historyData"
              :key="index"
              @click="historyClick(item)"
              v-if="index<=9"
            >
              <div class="history-name" >
                {{ item }}
              </div>
              <div
                class="delect-his-icon el-icon-close"
                @click.stop="delectCurrentHistory(index)"
              ></div>
            </div>
          </div>
        </div>
      </el-dialog>
    <div class="ai-asssistant-btn" @click="showIframe" v-if="inWhitelist">
        <i class="ai-asssistant-btn-icon"></i>开发助手
        
    </div>
   <div
      v-if="iframeVisible"
      class="draggable-container"
      ref="draggableContainer"
      :style="{
        top: `${dragTop}px`,
        left: `${dragLeft}px`,
        height: `${iframeHeight}px`,
      }"
      @mousedown="startDrag"
    >
      <div class="draggable-content"></div>
      <iframe 
        id="myIframe" 
        :src="aiUrl" 
        frameborder="0" 
        class="ifrma"
      ></iframe>
    </div>
     <iframe :src="aiUrl" style="width: 0;height: 0;overflow: hidden;">

     </iframe>
    <div class="feedback" @click="feedbackClick">
      <svg class="feedbackIcon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_10367_15753)">
          <path d="M7.22168 0.242188C10.2593 0.242188 12.8439 2.17736 13.8125 4.88184L6.86426 14.2334C3.16446 14.0472 0.221737 10.9882 0.22168 7.24219C0.22168 3.37625 3.35576 0.242275 7.22168 0.242188ZM2.79395 5.95312C2.16076 5.95312 1.64746 6.46643 1.64746 7.09961C1.64746 7.73279 2.16076 8.24609 2.79395 8.24609C3.42713 8.24609 3.94043 7.73279 3.94043 7.09961C3.94043 6.46643 3.42713 5.95313 2.79395 5.95312ZM6.28711 5.95312C5.65393 5.95312 5.14062 6.46643 5.14062 7.09961C5.14063 7.73279 5.65393 8.24609 6.28711 8.24609C6.92029 8.24609 7.43359 7.73279 7.43359 7.09961C7.43359 6.46643 6.92029 5.95313 6.28711 5.95312ZM9.78027 5.95312C9.14709 5.95312 8.63379 6.46643 8.63379 7.09961C8.63379 7.73279 9.14709 8.24609 9.78027 8.24609C10.4135 8.24609 10.9268 7.73279 10.9268 7.09961C10.9268 6.46643 10.4135 5.95313 9.78027 5.95312Z" fill="#FBFCFC"/>
          <path d="M13.8276 6.45009C14.1396 5.9944 14.762 5.87796 15.2177 6.19001L15.5412 6.41154C15.9969 6.72359 16.1133 7.34595 15.8013 7.80163L15.1568 8.74275L13.1831 7.3912L13.8276 6.45009Z" fill="#FBFCFC"/>
          <path d="M12.7847 7.97201L14.7584 9.32356L11.0682 14.5076C11.0188 14.5771 10.9524 14.6328 10.8753 14.6694L9.69465 15.2299C9.35781 15.3898 8.97075 15.1381 8.98036 14.7654L9.01518 13.4147C9.01774 13.3152 9.04995 13.2187 9.10767 13.1376L12.7847 7.97201Z" fill="#FBFCFC"/>
        </g>
        <defs>
          <clipPath id="clip0_10367_15753">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      问题反馈
    </div>
    <feedbackDialog  ref="feedbackDialogRef"/>
    <myDialog v-if="showMyDialog" title="" content="登陆后,可参与操作" ok="确定" @confirm="gotoLogin" @close="closeMyDialog" />
    </div>
  </template>
  <script>
  const reportAppConfig = {
    pv: {
      page: 120002,
      event_id: 800004,
      action_type: 3,
      area_id: 0,
    },
    "click-select": {
      page: 120002,
      event_id: 800005,
      action_type: 2,
      area_id: 0,
    },
    "click-all-select": {
      page: 120002,
      event_id: 800006,
      action_type: 2,
      area_id: 0,
    },
    "version-select": {
      page: 120002,
      event_id: 800007,
      action_type: 2,
      area_id: 0,
    },
    "click-content": {
      page: 120002,
      event_id: 800008,
      action_type: 1,
      area_id: 0,
    },
  };
  import {
    getApiJson,
    getApiClassList,
    getApiSortClassList,
    getApicppenumList,
    getApicppstructList,
    getApiClassDetailList,
    getApiglobalfuncList,
    getApiTreeList,
    search,
    report,
    getInWhiteList
  } from "../../services/api/index";
  import http from "../../services/apiGenerator";
  import tree from "../../utils/tree";
  import treeCopy from "../../utils/treeCopy";
  import getParmas from "../../assets/js/url";
  import eventBus from "./eventBus"
  import markDown from "./newPeopleRead.vue"
  import feedbackDialog from "../../components/feedbackDialog.vue"
  import myDialog from "../../components/myDialog.vue"
  export default {
    name: "demo",
    components: {
      treeCopy,
      tree,
      markDown,
      feedbackDialog,
      myDialog,
    },
    data() {
      return {
        historyData: [],
        inWhitelist:false,//是否在ai助手白名单中
        testId: "",
        path:"",
        input: "",
        selectVal: "",
        allSelect: "",
        value: "选项1",
        iframeVisible:false,

         dragTop: 0, // 初始 top（与 CSS 一致）
        dragLeft: 20, // 初始 left（与 CSS 一致）
        isDragging: false, // 是否正在拖拽
        initialX: 0, // 鼠标按下时的 X 坐标
        initialY: 0, // 鼠标按下时的 Y 坐标
        initialContainerTop: 0, // 拖拽开始时容器的 top 值（通过 ref 获取）
        initialContainerLeft: 0, // 拖拽开始时容器的 left 值（通过 ref 获取）
        iframeHeight: 762, // 将高度设置为动态高度

        className: "Class索引",
        viewSelect: true, //视图选择
        backC: {
          backgroundColor: "#F5F9FA",
        },
        options: [
          {
            value: "选项1",
            label: "1.0",
          },
        ],
        searchList: [],
        clTab: ["新人导读","类", "枚举", "数据类型", "全局函数"],
        isSelect: 0,
        data: [],
        oldData: [],
        defaultProps: {
          children: "Children",
          label: "Label",
        },
        api: "",
        viewData: "",
        iframeUrl:"",
        classDetailShow: false,
        ClassListData: "", //类列表
        enumListListData: "", //枚举列表
        selectData: [],
        contentData: [],
        apiEnc: [],
        apiLabel: "",
        treeList: [],
        address: "",
        rightSelect: "",
        rightSelectItem: "",
        count: 0,
        aiUrl:"",
        goToShow: false,
        topHeaderShow: false,
        leftHeadShow: false,
        handleScrollIndex: 0,
        handleleftScrollIndex: 0,
        other: "", //判断other存在
        ClassListIndex: 0,
        expendNode: false,
        wikiIframeHeight:"1720px",
        Localselcet: {},
        LocalselcetIndex: 0,
        leftIndex: "", //左侧偏移值
        mainIndex: "", //中间偏移值
        mainHeadIndex: "", //中间搜索框偏移值
        leftHaadIndex: "", //左边搜索框偏移值
        searchMessage: "", //搜索词违禁提示
        dialogVisible: false,
        serchLoading: false, // 搜索中
        isShowSerchingTips: false,
        searchPage: 1,
        haveMore: true, // 搜索结果是否还有更多
        inPost: false, // 是否请求中
        showMyDialog: false,
      };
    },
    props: {
      msg: String,
    },
    
    watch: {
      classDetailShow(val) {
        if (val) {
          this.leftIndex = "calc((100% - 1393px)/2)";
          this.mainIndex = "calc((100% - 893px)/2)";
          this.mainHeadIndex = " calc((100% - 899px)/2)";
        } else {
          this.leftIndex = "calc((100% - 1203px)/2)";
          this.mainIndex = "calc((100% - 696px)/2)";
          this.mainHeadIndex = " calc((100% - 703px)/2)";
        }
      },
      $route(nval,oval){
          console.log(nval)
          
          if(nval.name == 'demo' && nval.name != oval.name){
            
              // location.reload() 
              this.typeChoose(this.isSelect)
          }else if(nval.name != 'demo' ){
             this.classDetailShow =  getParmas("classDetailShow")
             this.apiEnc = JSON.parse(decodeURI(getParmas("apiEnc")))
             this.apiLabel = getParmas("apiLabel")
          }else if(nval.name == 'demo' && nval.name == oval.name){
              this.isSelect  = parseInt(getParmas("isSelect"))
              console.log("route变化了")
              this.typeChoose(this.isSelect)
          }
          // 路由或url参数变化时，同步tree-copy的选中状态
          this.syncTreeSelectionFromRoute();
      },
      // iframeHeight(val){
      //     this.iframeHeight  = val;
      // },
      // dialogVisible() {
      //   this.$nextTick(() => {
      //   document.getElementsByClassName('el-input__inner').focus();
      //   })
      // },
      allSelect() {
        this.remoteMethod(this.allSelect);
      },
    },
    methods: {
      gotoLogin () {
        let loginBaseUrl = location.port === '8082' ? 'https://developer-debug.gp.qq.com' : location.origin;
        let loginUrl = '/resources/?oasisRedirectUrl=' + encodeURIComponent(location.href)
        window.location.href = loginBaseUrl + loginUrl
      },
      closeMyDialog () {
        this.showMyDialog = false
      },
      feedbackClick () {
        const token = document.cookie.split('; ').find(row => row.startsWith('oasisSessionId='))?.split('=')[1] || ''
        console.log('token - ', token, !!token)
        if (!token) {
          return this.showMyDialog = true
        }
        console.log('this.$refs - ', this.$refs)
        this.$refs.feedbackDialogRef.changeDialog(true)
      },
    showIframe(){
        this.iframeVisible = true;
        self = this;
        if(this.iframeVisible){
            window.addEventListener('message', function(event) {
                if(event.data.message ){
                    self.iframeVisible = false
                }
            });
        }else{
            window.removeEventListener('message', responseListener);
        }
    },
    responseListenerInwhiteList(event){
        if(event.data.inWhiteList){
        if( event.data.inWhiteList == 'false'){
             this.inWhitelist = false;
        }else{
            this.inWhitelist = true;
        }
        window.removeEventListener('message', this.responseListenerInwhiteList);
        }
    },
     startDrag(e) {
      e.stopPropagation(); // 阻止事件冒泡到更上层
      e.preventDefault(); // 阻止默认拖拽样式
      if (!this.iframeVisible) return; // 仅当 iframe 可见时允许拖拽

      // 获取拖拽容器的 DOM 元素（通过 ref）
      const container = this.$refs.draggableContainer;
      if (!container) return;

      // 记录鼠标按下时的坐标
      this.initialX = e.clientX;
      this.initialY = e.clientY;

      // 记录容器当前的 top/left 值（通过 getBoundingClientRect）
      const rect = container.getBoundingClientRect();
      this.initialContainerTop = rect.top; // 容器顶部相对于视口的位置
      this.initialContainerLeft = rect.left; // 容器左侧相对于视口的位置

      // 标记正在拖拽
      this.isDragging = true;
      const iframe = document.querySelector("#myIframe");
      if (iframe) {
        iframe.contentWindow.addEventListener("mouseup", this.stopDrag);
      }

      // 绑定全局鼠标移动和松开事件
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },

    // 拖拽过程中更新位置
    onDrag(e) {
      if (!this.isDragging) return;

      // 计算鼠标移动的偏移量
      const deltaX = e.clientX - this.initialX; // 水平偏移（向右为正）
      const deltaY = e.clientY - this.initialY; // 垂直偏移（向下为正）

      // 计算新的 top/left（基于初始位置 + 偏移量）
      let newTop = this.initialContainerTop + deltaY;
      let newLeft = this.initialContainerLeft + deltaX;

      // 获取视口尺寸和容器尺寸（关键限制逻辑）
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const containerWidth = 500; // 与 CSS 中容器宽度一致
      const containerHeight = this.iframeHeight; // 与 CSS 中容器高度一致

       // 增加 10px 容差，避免像素级溢出
       const tolerance = 10;
      // 限制 top 范围：0 ≤ top ≤ 视口高度 - 容器高度
      newTop = Math.max(10, Math.min(newTop, viewportHeight - containerHeight - tolerance));
      // 限制 left 范围：0 ≤ left ≤ 视口宽度 - 容器宽度
      newLeft = Math.max(10, Math.min(newLeft, viewportWidth - containerWidth - tolerance));

      // 更新数据（触发视图更新）
      this.dragTop = newTop;
      this.dragLeft = newLeft;
    },

    // 结束拖拽（移除事件监听）
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    
    sendMessageToIframe(message, callback) {
    //    this.$nextTick(()=>{
    //     const messageId = Date.now().toString();
    //     const iframe = document.getElementById('myIframe');
    //     console.log(iframe,'sssssssssssss')

    //     // 临时监听响应
    //     const responseListener = function(event) {
    //         if (event.data.messageId === messageId) {
    //         window.removeEventListener('message', responseListener);
    //         callback(event.data.response);
    //         }
    //     };
        
    //     window.addEventListener('message', responseListener);
    //     // 发送消息
    //     // console.log(iframe.contentWindow.postMessage,'')
    //     iframe.contentWindow.postMessage({
    //         message,
    //         messageId
    //     }, '*');
    //    })
    },


    // 使用
       
      //删除全部历史纪律
      delectHistory() {
        this.historyData = [];
         localStorage.setItem("historyData",this.historyData)
      },
      //删除当前历史记录
      delectCurrentHistory(index) {
        this.historyData.splice(index, 1);
        localStorage.setItem("historyData",this.historyData)
      },
      selectFocus() {},
      selectBlur() {},
      async reportTLog(config, directory) {
        let mapConfig = reportAppConfig[config];
        try {
          let defaultConfig = { directory: directory ? directory : "" };
          let mergedConfig = Object.assign(defaultConfig, mapConfig);
          const [err, res] = await report(mergedConfig);
        } catch (err) {
          console.error("上报h5 tlog失败: ", err);
        }
      },
      testCom(data, key) {
        for (var i in data) {
          if (Array.isArray(data[i])) {
            let result = data[i].filter(
              (word) =>
                word.toLowerCase().indexOf(this.selectVal.toLowerCase()) > -1
            );
            if (result[0] != undefined) {
              if (key) {
                if (this.Localselcet[key]) {
                  // console.log(this.Localselcet[`${key}`]);
                  this.Localselcet[`${key}`][`${i}`] = result;
                } else {
                  this.Localselcet[key] = { [`${i}`]: result };
                }
              } else {
                this.Localselcet[`${i}`] = result;
              }
            }
          //   console.log("ke", this.Localselcet[key]);
          } else {
            this.testCom(data[i], i);
          }
          // console.log("ldds", this.Localselcet);
        }
        this.LocalselcetIndex += 1;
        if (this.LocalselcetIndex == this.ClassListIndex) {
          let count = 0;
          for (var j in this.Localselcet) {
            count += 1;
          }
          this.data = [];
          this.expendNode = true;
          this.ClassListCom(this.Localselcet, 0, count);
        }
      //   console.log(this.LocalselcetIndex);
      },
      handleScroll() {
        // if(timer != null) {
        //     clearTimeout(timer)
        // }
        if (this.handleScrollIndex >= 3) {
          this.screenHeight = document.getElementsByClassName(
            "mian-big"
          )[0].scrollTop;
          if (this.screenHeight >= 236) {
            this.goToShow = true;
          } else {
            this.goToShow = false;
          }
          if (this.screenHeight >= 90) {
            this.topHeaderShow = true;
          } else {
            this.topHeaderShow = false;
          }
          this.handleScrollIndex = 0;
        } else {
          this.handleScrollIndex++;
        }
      },
      handleleftScroll() {
        if (this.handleleftScrollIndex >= 3) {
          this.leftScreenHeight = document.getElementsByClassName(
            "letf"
          )[0].scrollTop;
          if (this.leftScreenHeight >= 88) {
            this.leftHeadShow = true;
          } else {
            this.leftHeadShow = false;
          }
        } else {
          this.handleleftScrollIndex++;
        }
      },
      goTop() {
        document.getElementsByClassName("mian-big")[0].scrollTop = 0;
      },
      //测试
      // test(val) {
      //   console.log(Boolean(val));
      //   console.log(val);
      // },
      //
      //全局搜索
      remoteMethod(query) {
        // if(this.query.length<1){
        //   return
        // }
        this.isShowSerchingTips = true;
        this.serchLoading = true;
        this.searchList = [];
        this.$nextTick(() => {
          this.search(query);
        });
      }, //搜索类
      selectClass() {
        if (this.selectVal.length >= 4) {
          this.localFilter(this.oldData);
          // this.data.forEach((item) => {
          //   this.localFilter(item.Children, item.Label, 0);
          // });
        } else if (this.selectVal.length == 0) {
          this.data = this.oldData;
          // this.getApiClassList();
          this.$refs.tree.store.defaultExpandAll = false;
        }
        this.$nextTick(() => {
          this.$refs.tree.store.defaultExpandAll = true;
        });
      //   console.log(this.$refs.tree.store);
        this.reportTLog("click-select");
      },
      //本地搜索筛选
      localFilter(data, key, count) {
        // 一级分类
      //   console.log("data23213", data);
        let data1 = data.map((item1, index) => {
          // 二级分类
          // {children:[]}
          let array1 = item1.Children.map((item2) => {
            //判断是否有三级子类  {children:[]}
            if (item2.Children) {
              let array3 = item2.Children.filter(
                (item3) =>
                  item3.Label.toLowerCase().indexOf(
                    this.selectVal.toLowerCase()
                  ) > -1
              );
              if (array3.length) {
                return { ...item2, Children: array3 };
              }
              return null;
            } else {
              if (
                item2.Label.toLowerCase().indexOf(this.selectVal.toLowerCase()) >
                -1
              ) {
                return item2;
              } else {
                return null;
              }
            }
          });
          if (array1.length) {
            return { ...item1, Children: array1 };
          } else {
            return null;
          }
        });
      //   console.log("data1", data1);
        let data2 = data1.map((item) => {
          let array4 = item.Children.filter((item2) => item2 != null);
          // console.log("arrry4", array4);
          if (array4.length) {
            return { ...item, Children: array4 };
          } else {
            return null;
          }
        });
        let data3 = data2.filter((item) => item != null);
        // if(data2){
        //     this.data = data3
        // }else{
        //     this.data = []
        // }
        this.data = data3;
      //   console.log("data2", data3);
      },
      //切换视图
      async getApiTreeList() {
        const [err, res] = await getApiTreeList();
        this.treeList = res;
        // console.log(this.treeList);
      //   console.log(err);
      },
      //获取白名单
      async getInWhiteListData() {
        const [err, res] = await getInWhiteList();
        this.treeList = res;
        // console.log(this.treeList);
      //   console.log(err);
      },
      async search(query) {
        if (query && query.length >= 1) {
          this.inPost = true
          const [err, res] = await search({ key: query,page: this.searchPage});
          this.inPost = false
          this.searchMessage = res ? res.message : "未检测到搜索结果";
          if (Array.isArray(res) && res.length > 0) {
            this.searchList.push(...res);
            this.isShowSerchingTips = false;
          }
          if(Array.isArray(res)) {
            if(res.length < 10) { // 小于10条后面没有了
              this.haveMore = false
            }else {
              this.haveMore = true
            }
          }
        }
        this.serchLoading = false;
      },
      scrollLoad () {
        // console.log('this.$refs.searchList.scrollTop - ', 111 * (this.searchList.length - 4) -50, this.$refs.searchList.scrollTop)
        if(this.$refs.searchList.scrollTop >= 111 * (this.searchList.length - 4) - 50) {
          // 下拉加载下一页
          this.antishakeLoadMore()
        }
      },
      // 请求文章防抖处理
      antishakeLoadMore () {
        if(!this.inPost && this.haveMore) {
          this.searchPage++
          this.search(this.allSelect)
        }
      },
      // 点击历史
      historyClick (item) {
        this.allSelect = item
      },

      changeView(val) {
        //   this.viewSelect = val;
      },
      handleOpenDlog() {
        this.dialogVisible = true;
        this.searchList = [];
        this.serchLoading = false;
        this.isShowSerchingTips = false;
        this.allSelect = "";
        this.$nextTick(() => {
          this.$refs.input.focus();
          this.$refs.searchList.addEventListener('scroll', this.scrollLoad)
        });
      },
      // 关闭弹框
      handleCloseModule() {
        this.dialogVisible = false;
        this.searchList = [];
        this.$refs.searchList.removeEventListener('scroll', this.scrollLoad)
        this.searchPage = 1
        this.haveMore = true
        this.inPost = false
        this.serchLoading = false;
        this.isShowSerchingTips = false;
        this.keyWord = this.allSelect;
        this.allSelect = "";
      },
      gotoDetail(val, key, type, content) {
      //   console.log(val,key,type);
        this.keyWord && this.historyData.unshift(this.keyWord);
        this.historyData   = [...new Set(this.historyData)];
        localStorage .setItem("historyData",this.historyData) 
        if (type) {
          this.reportTLog("click-all-select");
          
          switch (type) {
            case "class":
              this.isSelect = 1;
              this.apiEnc = [];
              this.apiEnc.push("类");
              // 锚点高亮
              if(content) {
                let str = content[0]
                let a = str.split(' ')[0]
                a = a.replace('<mark>', '').replace('</mark>', '')
                // if(/[\(\)]/.test(a)) {
                  let funName = a.split('(')
                  window.localStorage.setItem('searchFunHightLight', funName[0])
                // }
              }
              break;
            case "enum":
              this.isSelect = 2;
              this.apiEnc = [];
              this.apiEnc.push("枚举");
              break;
            case "struct":
              this.isSelect = 3;
              this.apiEnc = [];
              this.apiEnc.push("数据类型");
              break;
          }
        } else {
          this.reportTLog("click-content", val);
        }
        console.log("执行了")
        this.classDetailShow = true;
        this.apiLabel = val;
        this.getClassDetail(key, val);
        //   this.apiEnc.push(val);
      //   this.apiEnc.push(val)
        
      },
      // 测试按钮
      async getApiJson() {
        // 发起请求
        const [err, res] = await getApiJson();
      },
      //获取类列表
      async getApiSortClassList() {
        const [err, res] = await getApiSortClassList();
        this.ClassListData = res;
      },
      //获取类的详情列表
      async getApiClassDetailList() {
        const [err, res] = await getApiClassDetailList();
        //   this.ClassListData = res;
        //   console.log(this.ClassListData);
      },
      //获取枚举列表
      async getApicppenumList() {
        const [err, res] = await getApicppenumList();
        this.ClassListData = res;
      },
      //获取数据类型列表
      async getApicppstructList() {
        const [err, res] = await getApicppstructList();
        this.ClassListData = res;
      },
      //获取全局函数列表
      async getApiglobalfuncList() {
        const [err, res] = await getApiglobalfuncList();
        this.ClassListData = res;
      },
      //获取分组视图
      async getApiClassList() {
        const [err, res] = await getApiClassList();
        var obj = {};
        this.ClassList = res;
        let cuont = 0;
        for (var i in this.ClassList) {
          cuont += 1;
        }
        this.data = this.ClassList;
        this.oldData = this.ClassList;
        // tree 数据就绪后，根据当前路由同步选中
        this.syncTreeSelectionFromRoute();
        // console.log(this.data);
        //   this.ClassListCom(res, 0, cuont);
      },
      ClassListCom(res, deep, cuont) {
        for (var i in res) {
          if (Array.isArray(res[i])) {
            var obj = Object.assign({ children: [] });
            obj.label = i;
            res[i].forEach((item) => {
              obj.children.push({ label: item });
            });
            deep == 0
              ? this.data.push(obj)
              : this.data[this.data.length - 1].children.push(obj);
          } else {
            var obj = Object.assign({ children: [] });
            obj.label = i;
            this.data.push(obj);
            this.ClassListCom(res[i], 1, cuont);
          }
        }
        //   this.selectClassComputed(this.data)
        this.ClassListIndex += 1;
        if (!this.other) {
          this.data.map((item, index) => {
            if (item.label == "Others") {
              this.other = this.data.splice(index, 1);
            }
          });
        }
        if (this.ClassListIndex == cuont) {
          this.data.push(this.other[0]);
          this.oldData = this.data;
        }
      },
      typeChoose(index) {
        this.isSelect = index;
        this.classDetailShow = false;
        this.apiEnc = [];
        this.goTop()
        this.goToShow = false;
        console.log(index,"index+1")
        switch (index) {
          case 0: break;   
          case 1:
            this.getApiSortClassList();
            this.className = "Class  索引";
            this.apiEnc.push("类");
            break;
          case 2:
            this.getApicppenumList();
            this.className = "Enum  索引";
            this.apiEnc.push("枚举");
            break;
          case 3:
            this.getApicppstructList();
            this.className = "DataType  索引";
            this.apiEnc.push("数据类型");
            break;
          case 4:
            this.getApiglobalfuncList();
            this.className = "全局函数";
            this.apiEnc.push("全局函数");
            break;
        }
       
        this.$router.push({
          path: `/`,
          query: {
            classDetailShow: false,
            isSelect: index,
          },
        });
      },
      initClass(index) {
        switch (index) {
          case 1:
            this.getApiSortClassList();
           
            break;
          case 2:
            this.getApicppenumList();
          
            break;
          case 3:
            console.log("初始")
            this.getApicppstructList();
             
            break;
          case 4:
            console.log("初始")
            this.getApiglobalfuncList();
             
            break;
        }
      },
      handleNodeClick(data, node) {
        this.currentLabe = data.Label + ".json";
        console.log(data);
        if (!data.Children) {
          this.apiEnc = [];
          this.getParentNode(node.parent);
          this.$nextTick(()=>{
            this.apiLabel = data.Label;
          })
          this.reportTLog("click-content", this.apiLabel);
          // this.apiEnc.push(data.label);
        }
      },
      // 根据当前路由/url参数同步 tree-copy 的选中状态
      // - 当 url 对应某个 tree 叶子节点时，自动选中该节点
      // - 当 url 不对应任何 tree 节点（如首页或不存在的节点）时，取消选中
      syncTreeSelectionFromRoute() {
        this.$nextTick(() => {
          const tree = this.$refs.tree;
          if (!tree) return;
          // 只有当路由是 searchContent 详情页时才尝试选中对应节点
          const routeName = this.$route && this.$route.name;
          const query = (this.$route && this.$route.query) || {};
          // 从 query.path 中提取最后一个 '/' 与 '.json' 之间的值作为目标节点 Name
          // 例如 query.path = "xxx/yyy/SomeApi.json" => targetLabel = "SomeApi"
          let targetLabel = '';
          const rawPath = query.path || '';
          if (rawPath) {
            const match = /\/([^/]+)\.json(?:$|[?#])/.exec(rawPath);
            if (match) {
              targetLabel = match[1];
            } else {
              // 兜底：没有 .json 结尾时，取最后一个 '/' 之后的片段
              const idx = rawPath.lastIndexOf('/');
              targetLabel = idx >= 0 ? rawPath.slice(idx + 1).replace(/\.json$/, '') : rawPath.replace(/\.json$/, '');
            }
          }
          if (routeName === 'searchContent' && targetLabel) {
            // tree-copy 的 node-key 为 Name，url 中 apiLabel 对应节点的 Name
            // 先用 key 直接取 node（快速路径）
            let matchKey = null;
            const directNode = tree.getNode(targetLabel);
            if (directNode && directNode.data) {
              matchKey = directNode.data.Name;
            } else {
              // 兜底：递归遍历 data 查找 Name 匹配的节点（处理大小写/类型差异）
              const found = this.findNodeByName(this.data, targetLabel);
              if (found) matchKey = found.Name;
            }
            if (matchKey) {
              tree.setCurrentKey(matchKey, true);
              return;
            }
          }
          // 未匹配到节点则取消选中
          tree.setCurrentKey(null);
        });
      },
      // 递归在 tree 数据中按 Name 查找节点
      findNodeByName(list, name) {
        if (!Array.isArray(list) || !name) return null;
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          if (item && item.Name === name) return item;
          if (item && item.Children && item.Children.length) {
            const sub = this.findNodeByName(item.Children, name);
            if (sub) return sub;
          }
        }
        return null;
      },
      handleNodeClickCopy(data, node) {
        console.log(data, node);
        this.isSelect = 1;
        this.classDetailShow = true;
        console.log("789",data);
        this.getClassDetail(data.Path, data.Name);
      },
      getParentNode(node) {
        //   console.log(node);
        //   if(node.expanded)
        if (node.expanded) {
          this.api = node.data.Label + "/" + this.api;
          this.apiEnc.unshift(node.data.Label);
          this.getParentNode(node.parent);
        } else {
          this.isSelect = 1;
          this.classDetailShow = true;
          this.getClassDetail(node.Path, node.Name);
        }
      },
      onSelect(selectedKeys, info) {
        console.log("selected", selectedKeys, info);
      },
      getClassDetail(val, name) {
        let data = "";
        console.log(val);
        switch (this.isSelect) {
          case 1:
            data = val ? val : `class/detail/${this.api}${this.currentLabe}`;
            //   this.getApiClassDetailList();
            break;
          case 2:
            data = val ? val : `cppenum/detail/${this.api}${this.currentLabe}`;
            break;
          case 3:
            data = val ? val : `cppstruct/detail/${this.api}${this.currentLabe}`;
            break;
          case 4:
            data = val ? val : `globalfunc/detail/${this.api}${this.currentLabe}`;
            break;
        }
        this.api = "";
        this.path = data;
        console.log("data", data, name);
        // 判断跳转页面是否跟当前页面路由相同
        if(this.$route.params.path && name && this.$route.params.path == name) {
          this.$nextTick(() => {
            this.$router.go(0) 
          })
        }
        this.$router.push({
          path: `/searchContent/${name}`,
          query: {
            classDetailShow: this.classDetailShow,
            path: data,
            isSelect: this.isSelect,
            apiEnc:JSON.stringify(this.apiEnc),
            apiLabel:this.apiLabel
          },
        });
      },
    },
    mounted() {
    //    this.aiUrl = window.location.origin +'/aiWiki'
       this.aiUrl = window.location.origin +'/aiWiki?type=oasis'
       if (window.innerHeight < 782) {
      this.iframeHeight = window.innerHeight - 40;
    }
        this.dragTop = window.innerHeight - this.iframeHeight - 20;
      // this.aiUrl = 'http://localhost:8080/?type=oasis';
    //    this.getInWhiteListData()
       window.addEventListener('message', this.responseListenerInwhiteList)
      this.historyData = localStorage.getItem("historyData") ? localStorage.getItem("historyData").split(","):[]
      getParmas("classDetailShow")=='true' ? this.classDetailShow = true : false;
      this.isSelect = parseInt(getParmas("isSelect"))? parseInt(getParmas("isSelect")): 0;
      console.log("刷新了",this.isSelect, this.classDetailShow)
      if(this.isSelect && !this.classDetailShow){
          this.typeChoose(this.isSelect)
      }
      this.getApiClassList();
      this.reportTLog("pv");
      this.apiEnc = getParmas("apiEnc") && JSON.parse(decodeURI(getParmas("apiEnc")))
      console.log(this.apiEnc,'this.apiEnc')
      this.apiLabel = getParmas("apiLabel")
      // this.getClassDetail();
      // this.getApiSortClassList();
      // console.log(this.iframeHeight)
      // this.iframeUrl  = `${location.origin}/wiki/#/report.html?type=1&t=${new Date().getTime()}`
      this.iframeUrl  = location.origin.indexOf('localhost') == -1 ? `${location.origin}/wikieditor/#/preview/4?type=1` : 'https://developer-test.gp.qq.com/wikieditor/#/preview/4?type=1'
      // this.iframeUrl  = `https://developer.gp.qq.com/wikieditor/#/preview/4?type=1`

     
      // this.$nextTick(()=>{
      //     const iframe = document.querySelector('#iframe')
      //     _this = this;
      // 	if (iframe.attachEvent) {    
      // 		iframe.attachEvent("onload", function() {    
      //             _this.iframeHeight = parseInt(sessionStorage.getItem("iframeHeight"))+55+'px';
      // 		});    
      //     }
      // })
      setTimeout(()=>{
      //   let iframe = document.getElementById("iframe").contentWindow;
      //   console.log(iframe.document.getElementsByClassName("page")[0])
      //   this.ifrmeHeight = iframe.document.getElementsByClassName("page")[0].offsetHeight+100+'px';  
      //   console.log(this.ifrmeHight)
        this.initClass(this.isSelect);
        console.log(this.ClassListData)
      })
      this.getApiTreeList();
     if(this.classDetailShow){
        eventBus.$on('event',(key,val)=>{
          console.log("传值成功",key,val)
          this.gotoDetail(key,val,1)
      })
     }
      document
        .getElementsByClassName("mian-big")[0]
        .addEventListener("scroll", this.handleScroll, false);
      document
        .getElementsByClassName("letf")[0]
        .addEventListener("scroll", this.handleleftScroll, false);
      // setTimeout(() => {
      //   this.$refs.tree.updateKeyChildren(key, data);
      // }, 1000);
    },
  };
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss">
  @import "./index.scss";

.feedback {
  position: fixed;
  right: 0;
  bottom: 20%;
  width: 96px;
  height: 36px;
  line-height: 36px;
  background: linear-gradient(79deg, #3CA6AE -15.06%, #4BC8D2 113.88%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  z-index: 98;
  .feedbackIcon {
    margin-right: 4px;
  }
}
  </style>